import base from './base'
import service from './response'
import axios from 'axios'

/** *************** **/
/** 以下為前台 F_API **/
/** *************** **/

/** 1.權限管理(Account) 相關 API **/
// 1.登入 F_API 001
export const apiAccountLogin = data => { return service({ url: `${base.NukApi}/api/user/account/login`, method: 'post', data }) }
// 2.註冊 F_API 002
export const apiAccountRegister = data => { return service({ url: `${base.NukApi}/api/user/account/register`, method: 'post', data }) }
// 3.查詢 F_API 003
export const apiAccountQuery = data => { return service({ url: `${base.NukApi}/api/user/account/query`, method: 'post', data }) }
// 4.變更 F_API 004
export const apiAccountModify = data => { return service({ url: `${base.NukApi}/api/user/account/modify`, method: 'post', data }) }
// 5.啟用 F_API 014
export const apiAccount = data => { return service({ url: `${base.NukApi}/api/user/account/enable`, method: 'post', data }) }
// 6.忘記密碼 F_API 005
export const apiAccountForgetpw = data => { return service({ url: `${base.NukApi}/api/user/account/forgetpw`, method: 'post', data }) }

/** 2.繳款項目管理(Feeorder) 相關 API **/
// 1.查詢公開 F_API 006
export const apiFeeorderQuerypublic = data => { return service({ url: `${base.NukApi}/api/user/feeorder/querypublic`, method: 'post', data }) }
// 2.查詢個人 F_API 007
export const apiFeeorderQuerypersonal = data => { return service({ url: `${base.NukApi}/api/user/feeorder/querypersonal`, method: 'post', data }) }
// 3.查尋已繳款 F_API 008
export const apiFeeorderQuerypaid = data => { return service({ url: `${base.NukApi}/api/user/feeorder/querypaid`, method: 'post', data }) }
// 4.加入購物車 F_API 009
export const apiFeeorderShopadd = data => { return service({ url: `${base.NukApi}/api/user/feeorder/shopadd`, method: 'post', data }) }
// 5.自購物車移除 F_API 010
export const apiFeeorderShopdel = data => { return service({ url: `${base.NukApi}/api/user/feeorder/shopdel`, method: 'post', data }) }
// 6.查詢購物車 F_API 011
export const apiFeeorderShopquery = data => { return service({ url: `${base.NukApi}/api/user/feeorder/shopquery`, method: 'post', data }) }
export const apiFeeorderShopquerys = data => axios.post(`${base.NukApi}/api/user/feeorder/shopquery`, data)
// 7.購物車繳費 F_API 012
export const apiFeeorderShoppay = data => { return service({ url: `${base.NukApi}/api/user/feeorder/shoppay`, method: 'post', data }) }
export const apiFeeorderShoppays = data => axios.post(`${base.NukApi}/api/user/feeorder/shoppay`, data)
// 8.列印繳費單資訊生成 F_API013
export const apiFeeorderPrintgen = data => { return service({ url: `${base.NukApi}/api/user/feeorder/printgen`, method: 'post', data }) }
// 9.購物車繳款項目檢查 F_API015
export const apiFeeorderShopcheck = data => { return service({ url: `${base.NukApi}/api/user/feeorder/shopcheck`, method: 'post', data }) }

/** *************** **/
/** 以下為後台 B_API **/
/** *************** **/

/** 3.後台_權限管理(Privilege) 相關 API **/
// 1.職員登入 B_API 001
export const apiAdminAccountLogin = data => { return service({ url: `${base.NukApi}/api/admin/account/login`, method: 'post', data }) }
// 2.變更 B_API 002
export const apiPrivilegeModify = data => { return service({ url: `${base.NukApi}/api/admin/privilege/modify`, method: 'post', data }) }
// 3.查詢 B_API 003
export const apiPrivilegeQuery = data => { return service({ url: `${base.NukApi}/api/admin/privilege/query`, method: 'post', data }) }
// 4.申請 B_API 004
export const apiPrivilegeApply = data => { return service({ url: `${base.NukApi}/api/admin/privilege/apply`, method: 'post', data }) }
// 5.開通 B_API 005
export const apiPrivilegeEnable = data => { return service({ url: `${base.NukApi}/api/admin/privilege/enable`, method: 'post', data }) }
// 6.停用 B_API 006
export const apiPrivilegeDisable = data => { return service({ url: `${base.NukApi}/api/admin/privilege/disable`, method: 'post', data }) }
// 7.人員權限-重新發送 B_API 032
export const apiPrivilegeReset = data => { return service({ url: `${base.NukApi}/api/admin/privilege/reset`, method: 'post', data }) }

/** 4.後台_收費項目管理(Feeitem) 相關 API **/
// 1.申請 B_API 007
export const apiFeeitemApply = data => { return service({ url: `${base.NukApi}/api/admin/feeitem/apply`, method: 'post', data }) }
// 2.查詢 B_API 008
export const apiFeeitemQuery = data => { return service({ url: `${base.NukApi}/api/admin/feeitem/query`, method: 'post', data }) }
// 3.變更 B_API 009
export const apiFeeitemModify = data => { return service({ url: `${base.NukApi}/api/admin/feeitem/modify`, method: 'post', data }) }
// 4.審核通過 B_API 010
export const apiFeeitemEnable = data => { return service({ url: `${base.NukApi}/api/admin/feeitem/enable`, method: 'post', data }) }
// 5.新增繳款項目 B_API 011
export const apiFeeitemOrderadd = data => { return service({ url: `${base.NukApi}/api/admin/feeitem/orderadd`, method: 'post', data }) }
// 6.繳款項目_批次匯入 B_API 023
export const apiFeeitemOrderimport = (data, config) => axios.post(`${base.NukApi}/api/admin/feeitem/orderimport`, data, config)
// export const apiFeeitemOrderimport = (data) => { return service({ url: `${base.NukApi}/api/admin/feeitem/orderimport`, method: 'post', data }) }
// 7.刪除 B_API 024
export const apiFeeitemDelete = data => { return service({ url: `${base.NukApi}/api/admin/feeitem/delete`, method: 'post', data }) }

/** 5.後台_繳款項目管理(Feeorder) 相關 API **/
// 1.查詢繳費單號 B_API 012
export const apiFeeorderQuerypayorder = data => { return service({ url: `${base.NukApi}/api/admin/feeorder/querypayorder`, method: 'post', data }) }
// 2.現金繳納 B_API 013
export const apiFeeorderPaidcash = data => { return service({ url: `${base.NukApi}/api/admin/feeorder/paidcash`, method: 'post', data }) }
// 3.查詢明細 B_API 014
export const apiFeeorderQuerydetail = data => { return service({ url: `${base.NukApi}/api/admin/feeorder/querydetail`, method: 'post', data }) }
// export const apiFeeorderQuerydetail = data => axios.post(`${base.NukApi}/api/admin/feeorder/querydetail`, data)
// 4.繳款項目統計報表匯出 B_API 025
export const apiFeeorderDetailexport = data => { return service({ url: `${base.NukApi}/api/admin/feeorder/detailexport`, method: 'post', data }) }
// 5.作廢 B_API 015
export const apiFeeorderCancel = data => { return service({ url: `${base.NukApi}/api/admin/feeorder/cancel`, method: 'post', data }) }
// 6.取得收入傳票資訊 B_API 029
export const apiFeeorderGetreceipt = data => { return service({ url: `${base.NukApi}/api/admin/feeorder/getreceipt`, method: 'post', data }) }
// 7.退費申請 B_API 016
export const apiFeeorderRefund = data => { return service({ url: `${base.NukApi}/api/admin/feeorder/refund`, method: 'post', data }) }
// 8.退費印領清冊匯出 B_API 026
export const apiFeeorderRefundexport = data => { return service({ url: `${base.NukApi}/api/admin/feeorder/refundexport`, method: 'post', data }) }
// 9.備註編輯 B_API 017
export const apiFeeorderEdit = data => { return service({ url: `${base.NukApi}/api/admin/feeorder/edit`, method: 'post', data }) }

/** 6.後台_銷帳管理及報表(Report) 相關 API **/
// 1.查詢_銷帳明細表 B_API 018
export const apiReportQuerydetail = data => { return service({ url: `${base.NukApi}/api/admin/report/querydetail`, method: 'post', data }) }
// 2.入帳_銷帳明細表 B_API 019
export const apiReportDebtconfirm = data => { return service({ url: `${base.NukApi}/api/admin/report/debtconfirm`, method: 'post', data }) }
// 3.匯出_銷帳明細表 B_API 020
export const apiReportDetailexport = data => { return service({ url: `${base.NukApi}/api/admin/report/detailexport`, method: 'post', data }) }
// 4手續費調整_銷帳明細表 B_API 027
export const apiReportChargerevise = data => { return service({ url: `${base.NukApi}/api/admin/report/chargerevise`, method: 'post', data }) }
// 5.查詢_銷帳總表 B_API 021
export const apiReportQuerysummary = data => { return service({ url: `${base.NukApi}/api/admin/report/querysummary`, method: 'post', data }) }
// 6.匯出_銷帳總表 B_API 022
export const apiReportSummaryexport = data => { return service({ url: `${base.NukApi}/api/admin/report/summaryexport`, method: 'post', data }) }
// 7.重複繳費清單-查詢 B_API 030
export const apiReportQueryduplicate = data => { return service({ url: `${base.NukApi}/api/admin/report/queryduplicate`, method: 'post', data }) }
// 8.重複繳費清單-匯出 B_API 031
export const apiReportDuplicateexport = data => { return service({ url: `${base.NukApi}/api/admin/report/duplicateexport`, method: 'post', data }) }

/** *************** **/
/** 以下為公用 P_API **/
/** *************** **/
// 1.學校單位代碼對照表 P_API001
export const apiDeptid = data => { return service({ url: `${base.NukApi}/api/public/deptid/query`, method: 'post', data }) }
// 2.異質系統代碼對照表 P_API002
export const apiSysid = data => { return service({ url: `${base.NukApi}/api/public/sysid/query`, method: 'post', data }) }

/** *************** **/
/** 以下為金流 L_API **/
/** *************** **/
// 1.LINE Pay付款保留 L_API001
export const apiLinePay = data => { return service({ url: `${base.LineApi}/api/line/reserve`, method: 'post', data }) }
// export const apiLinePay = data => axios.post(`${base.LineApi}/api/line/reserve`, data)
// 2.聯合信用卡_取得交易授權 CC_ECPG_API001
export const apiGettxnauth = data => { return service({ url: `${base.CardApi}/api/creditcard/ecpg/gettxnauth`, method: 'post', data }) }
// 3.聯合信用卡_授權結果查詢 CC_ECPG_API002
export const apiQueryauth = data => { return service({ url: `${base.CardApi}/api/creditcard/ecpg/queryauth`, method: 'post', data }) }
